/* PawMates — My Account Page Logic */
(function () {
  'use strict';

  var HUB = 'https://hub2.pawmates.co.in';

  function qs(id) { return document.getElementById(id); }

  function petIcon(species) {
    if (!species) return '🐾';
    var s = species.toLowerCase();
    if (s.indexOf('cat') !== -1) return '🐱';
    return '🐶';
  }

  // ── Show/hide views ────────────────────────────────────────────────────────
  function showLoggedIn(customerData) {
    qs('pm-loading-state').style.display  = 'none';
    qs('pm-logged-out-view').style.display = 'none';
    qs('pm-logged-in-view').style.display  = 'block';

    if (customerData) {
      var rawName = customerData.first_name || customerData.email || '';
      // If we only have email, use the part before @
      var name = rawName.indexOf('@') !== -1 ? rawName.split('@')[0] : rawName;
      if (name && qs('pm-greeting')) {
        qs('pm-greeting').textContent = 'Hey, ' + name + '! 👋';
      }
      if (customerData.email && qs('pm-customer-email')) {
        qs('pm-customer-email').textContent = customerData.email;
      }
      if (qs('pm-avatar-initials')) {
        qs('pm-avatar-initials').textContent = name ? name[0].toUpperCase() : '🐾';
      }
    }
  }

  function showLoggedOut() {
    qs('pm-loading-state').style.display  = 'none';
    qs('pm-logged-in-view').style.display  = 'none';
    qs('pm-logged-out-view').style.display = 'block';
  }

  // ── Pet rendering ──────────────────────────────────────────────────────────
  function renderPets(pets) {
    var container = qs('pm-pets-container');
    if (!container) return;
    if (!pets || pets.length === 0) {
      container.innerHTML = '<div class="pm-no-pets"><p>No pets added yet.</p>' +
        '<a href="/pages/my-pets">Add your first pet \u2192</a></div>';
      return;
    }
    // Build Manage Pets URL with email pre-filled if available
    var managePetsUrl = '/pages/my-pets';
    try {
      var raw = localStorage.getItem('pm_auth');
      if (raw) {
        var auth = JSON.parse(raw);
        if (auth && auth.email) managePetsUrl = '/pages/my-pets';
      }
    } catch(e) {}
    // Update Manage Pets button href
    var manageBtn = document.querySelector('.pm-pet-card .pm-btn-outline');
    if (manageBtn) manageBtn.href = managePetsUrl;

    var html = '';
    for (var i = 0; i < pets.length; i++) {
      var pet = pets[i];
      var photoHtml = pet.photo_url
        ? '<img src="' + pet.photo_url + '" alt="' + (pet.name || '') + '" class="pm-pet-photo">'
        : '<div class="pm-pet-photo-placeholder">' + petIcon(pet.species) + '</div>';
      var badge = i === 0 ? '<span class="pm-primary-badge">Primary</span>' : '';
      var parts = [];
      if (pet.breed) parts.push(pet.breed);
      if (pet.age)   parts.push(pet.age + ' old');
      var meta = parts.join(' · ');
      var editUrl = '/pages/my-pets?pet=' + i;
      html += '<a href="' + editUrl + '" class="pm-pet-item pm-pet-link">' + photoHtml +
        '<div class="pm-pet-info"><p class="pm-pet-name">' + (pet.name || 'Unnamed') + ' ' + badge + '</p>' +
        (meta ? '<p class="pm-pet-meta">' + meta + '</p>' : '') +
        '</div><span class="pm-pet-edit">Edit →</span></a>';
    }
    container.innerHTML = '<div class="pm-pet-list">' + html + '</div>';
  }

  function stripMarkdown(text) {
    if (!text) return '';
    return text
      .replace(/^#+\s*/gm, '')           // remove # headings
      .replace(/\*\*(.+?)\*\*/g, '$1')  // remove **bold**
      .replace(/\*(.+?)\*/g, '$1')       // remove *italic*
      .replace(/^[-*]\s+/gm, '• ')       // bullet points
      .trim();
  }

  function renderTip(tipData) {
    var section = qs('pm-tip-section');
    var content = qs('pm-tip-content');
    if (!section || !content) return;
    if (!tipData || !tipData.tip) { section.style.display = 'none'; return; }
    var cleanTip = stripMarkdown(tipData.tip);
    content.innerHTML = '<p class="pm-tip-text">' + cleanTip + '</p>' +
      (tipData.pet_name ? '<p class="pm-tip-pet">For ' + tipData.pet_name + '</p>' : '');
    section.style.display = 'block';
  }

  function loadAITip(pet) {
    if (!pet) return;
    var section = qs('pm-tip-section');
    var content = qs('pm-tip-content');
    if (section) section.style.display = 'block';
    if (content) content.innerHTML = '<p class="pm-loading">Koda is thinking…</p>';
    fetch(HUB + '/api/care-tip', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ pet: pet })
    })
      .then(function(r) { return r.json(); })
      .then(function(data) { renderTip(data); })
      .catch(function() { if (section) section.style.display = 'none'; });
  }

  // ── Pet data via localStorage fallback ─────────────────────────────────────
  function tryLocalStoragePets() {
    var auth = null;
    try { auth = JSON.parse(localStorage.getItem('pm_auth') || 'null'); } catch(e) {}
    if (auth && auth.email && auth.token) {
      showLoggedIn({ email: auth.email });
      fetch(HUB + '/api/pet-data?email=' + encodeURIComponent(auth.email) +
                  '&token=' + encodeURIComponent(auth.token))
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (data.ok && data.pets) {
            renderPets(data.pets);
            if (data.pets.length > 0) loadAITip(data.pets[0]);
          } else {
            renderPets([]);
          }
        })
        .catch(function() { renderPets([]); });
    } else {
      showLoggedOut();
    }
  }

  // ── Main init ──────────────────────────────────────────────────────────────
  function init() {
    // Step 1: App Proxy — Shopify injects logged_in_customer_id automatically
    fetch('/apps/pawmates/pet-data')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.logged_in) {
          // Store email from proxy into localStorage so my-pets can pre-fill
          if (data.customer_email) {
            try {
              var existing = JSON.parse(localStorage.getItem('pm_auth') || '{}');
              existing.email = data.customer_email;
              if (data.customer_first_name) existing.first_name = data.customer_first_name;
              localStorage.setItem('pm_auth', JSON.stringify(existing));
            } catch(e) {}
          }
          var custData = { email: data.customer_email, first_name: data.customer_first_name };
          showLoggedIn(custData);
          if (data.has_pet && data.pets) {
            renderPets(data.pets);
            loadAITip(data.primary_pet || data.pets[0]);
          } else {
            renderPets([]);
          }
        } else {
          // Step 2: localStorage fallback (pet profile saved on this device)
          tryLocalStoragePets();
        }
      })
      .catch(function() {
        tryLocalStoragePets();
      });

    // Refresh tip button
    var refreshBtn = qs('pm-refresh-tip');
    if (refreshBtn) {
      refreshBtn.addEventListener('click', function () {
        fetch('/apps/pawmates/pet-data')
          .then(function(r) { return r.json(); })
          .then(function(data) { if (data.primary_pet) loadAITip(data.primary_pet); });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
